import ProxyClient from './clients/ProxyClient';

export const getLastUserDeal = async (userId: string) => {
  const { data } = await ProxyClient.get('/deals', { params: { userId } });

  return data;
};
